import api from "./axios";
import type { FaqCategory, FaqItem } from "@/models/FAQ";
import type { ApiDataEnvelope } from "@/struct/ApiEnvelope";

export default class FaqService {
  getFaqCategories = () => {
    return api.get<ApiDataEnvelope<FaqCategory[]>>(
      "/api/web-api/public/get-faq-categories"
    );
  };
  getFaq = () => {
    return api.get<ApiDataEnvelope<FaqItem[]>>("/api/web-api/public/get-faq");
  };
}
